<div
  class="customized-table-cell"
  [style.width]="resolvedTableCellWidth"
>
  <ng-template appCustomizedTableCellHost></ng-template>
</div>
